import { useParams } from "react-router";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { Document } from "../../../../../types/working-model";
import { bytesToString, extractFileType } from "../../../../../utils/utils";
import Icon, { COLORS, ICONS } from "../../../../general-ui/icon";
import { TypographyItem } from "../../../../general-ui/typography-item/typography-item";
import { ParamsProps } from "../../../live-event";
import './document-card.scss';

interface DocProps {
	document: Document;
	template: TemplateClassNames
}

const DocumentCard: React.FC<DocProps> = ({ document, template }) => {
	const { language }: ParamsProps = useParams();

	const file = extractFileType(document.original_name);
	const title = file.toUpperCase();
	const fileSize = bytesToString(document.filesize, 0);


	return (
		<div
			className="document"
		>
			<div className="image-container">
				<a
					className="document-download"
					rel="noreferrer"
					target="_blank"
					href={document.location}
				>
					<div className="document-icon">
						<Icon name={ICONS.VIEWERS_EYE} size={20} color={COLORS.WHITE} />
						<span>{title}</span>
					</div>
					<div className="document-icon">
						<Icon name={ICONS.CLOUD_DOWNLOAD} size={18} color={COLORS.WHITE} />
						<span>{fileSize}</span>
					</div>
				</a>
				{document.thumbnail ? (
					<img
						src={document.thumbnail}
						alt={document.display_name.base}
					/>
				) : (
					<div className="document-placeholder"></div>
				)}
			</div>

			<div className="document-data">
				<TypographyItem tagName="h4" className="evt-heading-4" template={template}>
					{document.display_name[language] || document.display_name.base}
				</TypographyItem>
			</div>
		</div>
	);
};

export default DocumentCard;